import { Col } from "antd";

import { HEADLINE_ORIENTATION } from "../../../constants/props";
import { ABOUT_US_CONTENT } from "../../../constants/content/pages/about-us";
import { USP_VALUES } from "../../../constants/content/shared/values";

import Headline from "../../../components/headline/headline";
import AboutCard from "../../../components/about-card/about-card";
import TeaserTeam from "../../../components/teaser-team/teaser-team";
import ProfileCard from "../../../components/profile-card/profile-card";
import CustomRow from "../../../shared/costum-row/costum-row";
import CustomDivider from "../../../shared/custom-divider/custom-divider";
import Usp from "../../../components/usp/usp";
import ContactUs from "../../../components/contact-us/contact-us";

import "./styles.scss";
import useBreakpoints from "../../../hooks/use-breakpoints";
import { BREAKPOINTS } from "../../../constants/styles";

const AboutUs = () => {
  const currentBreakpoint = useBreakpoints();
  const isMobile = currentBreakpoint === BREAKPOINTS.MOBILE.type;

  return (
    <div className="about-us-page">
      <div className="about-us-content-spacing">
        <Headline
          title={ABOUT_US_CONTENT.headline.title}
          subtitle={ABOUT_US_CONTENT.headline.subtitle}
          orientation={HEADLINE_ORIENTATION.BOTTOM}
        />
        <CustomDivider />
      </div>
      {/* Mission Section */}
      <AboutCard
        title={ABOUT_US_CONTENT.mission.title}
        description={ABOUT_US_CONTENT.mission.description}
        imageSrc={ABOUT_US_CONTENT.mission.imageSrc}
      />

      <div className="about-us-content-spacing">
        <CustomDivider />
      </div>
      <AboutCard
        title={ABOUT_US_CONTENT.vision.title}
        description={ABOUT_US_CONTENT.vision.description}
        imageSrc={ABOUT_US_CONTENT.vision.imageSrc}
      />

      {/* Values Section */}
      <CustomRow
        gutter={isMobile ? [0, 60] : [0, 100]}
        justify="space-between"
        className="values-container"
      >
        <Col span={24}>
          <CustomRow
            justify="space-between"
            gutter={isMobile ? [16, 60] : [0, 100]}
            isEdgeToEdge
            isMarginNone
          >
            {USP_VALUES.slice(0, 2).map((usp, index) => (
              <Col
                className={index === 1 ? "usp-right" : ""}
                key={usp.type}
                xxl={6}
                xl={8}
                lg={9}
                md={9}
                sm={12}
                xs={12}
              >
                <Usp
                  type={usp.type}
                  title={usp.title}
                  description={usp.description}
                />
              </Col>
            ))}
          </CustomRow>
        </Col>
        <Col span={24}>
          <CustomRow
            justify="space-between"
            gutter={isMobile ? [16, 60] : [0, 100]}
            isEdgeToEdge
            isMarginNone
          >
            {USP_VALUES.slice(2, 4).map((usp, index) => (
              <Col
                key={usp.type}
                className={index === 1 ? "usp-right" : ""}
                xxl={6}
                xl={8}
                lg={9}
                md={9}
                sm={12}
                xs={12}
              >
                <Usp
                  type={usp.type}
                  title={usp.title}
                  description={usp.description}
                />
              </Col>
            ))}
          </CustomRow>
        </Col>
      </CustomRow>

      <TeaserTeam />

      <div className="about-us-content-spacing">
        <CustomRow
          isEdgeToEdge
          gutter={isMobile ? [0, 40] : [20, 0]}
          className="profile-cards-row"
          isMarginNone={!isMobile}
        >
          {ABOUT_US_CONTENT.teamMembers.map((member, index) => (
            <Col key={index} xxl={6} xl={6} lg={6} md={12} sm={24} xs={24}>
              <ProfileCard
                name={member.name}
                title={member.title}
                imageSrc={member.imageSrc}
                linkedinUrl={member.linkedinUrl}
              />
            </Col>
          ))}
        </CustomRow>
      </div>

      <ContactUs />
    </div>
  );
};

export default AboutUs;
